// extracted by mini-css-extract-plugin
export default {"main":"Xaa-z"};